"use client";

import { useTranslations } from "next-intl";
import type { SliderContext } from ".";
import { cn } from "../../helpers/classNames";
import { Button } from "../Button";
import { sendError } from "../ErrorBoundary/helpers";
import styles from "./arrow.module.scss";

type Direction = "left" | "right";

type Props = {
    direction: Direction;
    context: SliderContext;
    onClickAction: () => void;
};

export const Arrow: React.FC<Props> = ({
    direction,
    context,
    onClickAction,
}) => {
    const t = useTranslations("component.slider.arrow");
    const isLeft = direction === "left";
    const isRight = direction === "right";

    try {
        if (context === "forecastNavigation") {
            return (
                <>
                    <Button
                        variant="unstyled"
                        className={cn(
                            styles.arrow,
                            styles.arrowForecastNavigation,
                            isLeft && styles.leftForecastNavigation,
                            isRight && styles.rightForecastNavigation
                        )}
                        onClick={onClickAction}
                        aria-label={
                            isLeft
                                ? t("label.scrollLeft")
                                : t("label.scrollRight")
                        }
                    >
                        <span className="icon-dropdown" />
                    </Button>
                </>
            );
        } else if (context === "topLocations") {
            return (
                <>
                    <Button
                        variant="unstyled"
                        className={cn(
                            styles.arrow,
                            styles.arrowTopLocations,
                            isLeft && styles.leftTopLocations,
                            isRight && styles.rightTopLocations
                        )}
                        onClick={onClickAction}
                        aria-label={
                            isLeft
                                ? t("label.scrollLeft")
                                : t("label.scrollRight")
                        }
                    >
                        <span className="icon-dropdown" />
                    </Button>
                </>
            );
        }

        // context="miamap"
        return (
            <>
                <Button
                    variant="unstyled"
                    className={cn(
                        styles.arrow,
                        styles.arrowMiaMap,
                        isLeft && styles.leftMiaMap,
                        isRight && styles.rightMiaMap
                    )}
                    onClick={onClickAction}
                    aria-label={
                        isLeft ? t("label.scrollLeft") : t("label.scrollRight")
                    }
                >
                    <span className="icon-arrow" />
                </Button>
            </>
        );
    } catch (e) {
        sendError(e);
        return null;
    }
};
